import React from "react";
import {
  Checkbox,
  Flex,
  Icon,
  IconButton,
  Spacer,
  Tag,
  Text
} from "@chakra-ui/react";
import { IoChevronForward } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { AnestheticProtocol, SelectionContext } from "../../duck";

interface ProtocolProps {
  data: AnestheticProtocol;
  last: boolean;
}

const Protocol: React.FC<ProtocolProps> = ({ data, last }) => {
  const { selected, setSelected } = React.useContext(SelectionContext);
  const navigate = useNavigate();

  const isProtocolSelected = selected.some(
    protocol => protocol._id === data._id
  );

  const onSelect = () => {
    const newSelected = isProtocolSelected
      ? selected.filter(protocol => protocol._id !== data._id)
      : [...selected, data];
    setSelected(newSelected);
  };

  return (
    <Flex
      py={6}
      alignItems="center"
      borderBottom={last ? 0 : "1px solid"}
      borderColor="gray.100"
    >
      <Flex columnGap={3} alignItems="center">
        <Checkbox
          size="lg"
          isChecked={isProtocolSelected}
          onChange={onSelect}
        />
        <Text
          as={Link}
          to={`/anesthetic-protocols/${data._id}`}
          fontWeight="semibold"
          fontSize="lg"
          lineHeight={7}
          color="gray.700"
        >
          {data.name}
        </Text>
        {data.defaultProtocol && (
          <Tag size="sm" backgroundColor="basic.500" color="white">
            Default
          </Tag>
        )}
      </Flex>

      <Spacer />
      <IconButton
        minW={6}
        h={6}
        onClick={() => navigate(`/anesthetic-protocols/${data._id}`)}
        aria-label="Open anesthetic protocol"
        icon={<Icon as={IoChevronForward} boxSize="24px" color="gray.700" />}
        variant="unstyled"
      />
    </Flex>
  );
};

export default Protocol;
